<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">
				고객검색
				<span class="sub" v-if="bidList.length">브리핑대기로 저장할 물건 {{ bidList.length }}건 · 물건번호 {{ bidList.join(', ') }}</span>
				<span class="sub" v-if="scopeNote">{{ scopeNote }}</span>
			</div>
			<div class="search-top">
				<div class="left">
					<label class="input-label">고객명</label>
					<input class="form-control sm" type="text" v-model="searchOptions_.clientName" />
					<label class="input-label">연락처</label>
					<input class="form-control sm" type="text" v-model="searchOptions_.clientMobile" />
					<label class="input-label">찾는물건금액</label>
					<input class="form-control xsm" type="number" placeholder="만" v-model="searchOptions_.monthly_rent_S" />
					<span class="search-top--text">~</span>
					<input class="form-control xsm" type="number" placeholder="만" v-model="searchOptions_.monthly_rent_E" />
					<label class="input-label">찾는물건위치</label>
					<input class="form-control sm" type="text" v-model="searchOptions_.findArea" />
					<label class="input-label">관리등급</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="st" @change="btnStOption" />
						<span class="checkbox"></span>
						<span class="text">전체</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'A'" />
						<span class="checkbox"></span>
						<span class="text">A</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'B'" />
						<span class="checkbox"></span>
						<span class="text">B</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'C'" />
						<span class="checkbox"></span>
						<span class="text">C</span>
					</label>
					<!-- 매매 고객 창(UserAdmin2)과 같은 담당자 선택. 처음에는 본인이고 전체·다른 담당자로 넓힐 수 있다. -->
					<label class="input-label">담당자</label>
					<select v-model="searchOptions_.mId" class="form-control select sm">
						<option value="">전체</option>
						<option v-for="c in memList" :key="'mgr_' + c.mem_uid" :value="c.mem_uid">
							{{ c.mem_name }} {{ c.mem_rank_name }}
						</option>
					</select>
				</div>
				<div class="right">
					<button type="button" class="btn btn-primary" @click="btnSearch">검색</button>
				</div>
			</div>
		</div>
		<div class="section">
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 1 }" @click="changeMenu(1)">
					임차인
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 2 }" @click="changeMenu(2)">
					임대인
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 3 }" @click="changeMenu(3)">
					블랙리스트
				</button>
				<div class="right">
					<button type="button" class="btn btn-sm btn-secondary" @click="btnOnSaveBrif">저장</button>
				</div>
			</div>
			<div class="tab-con">
				<div class="table-wrap">
					<table class="table click">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="brifSt" @change="btnOnAddBrif" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>번호</th>
							<th>담당자</th>
							<th>관리등급</th>
							<th>고객분류</th>
							<th>고객명</th>
							<th>휴대폰</th>
							<th>보증금</th>
							<th>월고정비</th>
							<th>필요 면적</th>
							<th>찾는위치</th>
							<th>등록일시</th>
							<th>최근상담</th>
						</tr>
						<tr v-for="item in itemList" :key="'useradmin_' + item.client_uid" @click="btnOnDetail(item.client_uid)">
							<td @click.stop>
								<label class="input-checkbox">
									<input type="checkbox" v-model="item.brifSt" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>{{ item.client_uid }}</td>
							<td>{{ item.mem_name }} {{ item.mem_rank_name }}</td>
							<td>{{ item.mgr_level }}</td>
							<td>{{ $CLIENT_TYPE[item.client_type] }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.mobile }}</td>
							<td>{{ $formatNumber(item.deposit) }}</td>
							<td>{{ $formatNumber(item.monthly_fixed) }}</td>
							<td>{{ $formatArea(item.req_area_py) }}</td>
							<td>{{ item.findArea }}</td>
							<td>{{ item.reg_date }}</td>
							<td>{{ item.assign_date == '0000-00-00 00:00' ? '' : item.assign_date }}</td>
						</tr>
					</table>
				</div>
				<ul class="pagination b-pagination pagination-sm" v-if="pageData != null && pageData.list.length">
					<li class="page-item" v-bind:class="{ disabled: 1 == page }">
						<button type="button" class="page-link" @click="getItemList(1)">
							<b-icon-chevron-double-left />
						</button>
					</li>

					<li class="page-item" v-bind:class="{ disabled: pageData.first == null }">
						<button type="button" class="page-link" @click="pageData.first !== null ? getItemList(pageData.first) : ''">
							<b-icon-chevron-left />
						</button>
					</li>
					<li
						v-for="pg in pageData.list"
						v-bind:key="'pg_' + pg"
						class="page-item"
						v-bind:class="{ active: pageData.currentPage == pg }"
					>
						<button type="button" class="page-link" @click="getItemList(pg)">{{ pg }}</button>
					</li>
					<li class="page-item" v-bind:class="{ disabled: pageData.end == null }">
						<button type="button" class="page-link" @click="pageData.end !== null ? getItemList(pageData.end) : ''">
							<b-icon-chevron-right />
						</button>
					</li>

					<li class="page-item" v-bind:class="{ disabled: pageData.totalPage == page }">
						<button type="button" class="page-link" @click="getItemList(pageData.totalPage)">
							<b-icon-chevron-double-right />
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UserAdmin',
	components: {},
	data() {
		return {
			itemList: [],
			memList: [],
			menuType: 1,

			page: 1,
			pageData: null,
			totalCount: null,
			// 목록 SP(SP_R_USER_ADMIN·_MY)가 한 번에 20건만 준다(LIMIT pg, 20). 50 으로 두면
			// 2쪽이 50번째부터 시작해 21~50번째 고객이 어느 쪽에도 나오지 않는다.
			itemSize: 20,
			blockSize: 5,

			isRegisterPopupShow: false,
			isDetailPopupShow: false,

			st: true,
			searchOptions: {
				clientType: 'lessee',
				clientName: '',
				clientMobile: '',
				clientLevel: ['A', 'B', 'C'],
				mId: '',
				monthly_rent_S: '',
				monthly_rent_E: '',
				findArea: '',
			},

			searchOptions_: {
				clientType: 'lessee',
				clientName: '',
				clientMobile: '',
				clientLevel: ['A', 'B', 'C'],
				mId: '',
				monthly_rent_S: '',
				monthly_rent_E: '',
				findArea: '',
			},

			addInfo: {
				mgrUid: '',
				clientType: 'lessee', //고객구분
				mgrLevel: 'C', //관리등급

				deposit: 0, //보증금,
				monthly_rent: 0, //월세
				main_fee: 0, //관리비
				rent_area_m2: 0, //계약면적
				net_area_m2: 0, //전용면적
				end_date: '', //계약만기일
				monthly_fixed: 0, //월고정비
				req_area_py: 0, //필요면적
				addr: '', //주소

				clientName: '', //고객명
				clientMobile1: '', //연락처
				clientMobile2: '', //연락처
				clientMobileMemo1: '', //연락처
				clientMobileMemo2: '', //연락처
				clientEmail: '', //이메일
				clientMemo: '', //메모

				findArea: '', //찾는위치

				company: '',
				officeSt: '',
				likePick: '',
				conditions: '',
				inDate: '',
				sector: '',
				interior: '',
				route: '',
			},

			brifSt: false,
			brifList: [],

			bidList: [],
			myMid: '',
			scopeNote: '',
			// 목록 요청 번호. 늦게 도착한 옛 응답이 새 목록을 덮지 않게 한다(탭을 빠르게 바꾸는 경우).
			listSeq: 0,
			// 창을 연 뒤 담당자가 탭·검색을 먼저 건드렸는가. 그러면 초기값(내 고객)으로 덮지 않는다.
			touched: false,
		};
	},
	created() {
		// 저장할 물건: 임대검색에서 고른 여러 건 또는 물건자료(매물 상세)의 한 건.
		this.bidList = String(this.$route.query.brifList || '')
			.split(',')
			.map(s => s.trim())
			.filter(Boolean);
		this.init();
	},
	methods: {
		/**
		 * 각자 담당자별로: 임차인 탭은 처음에 내 담당 고객만 보여 준다. 담당자 선택을 바꾸면
		 * 다른 담당자·전체도 볼 수 있다(볼 수 있는 범위 자체는 서버가 직급 열람범위로 정한다).
		 * 담당자 명단에 내가 없으면 전체로 둔다. 선택 상자는 빈 칸인데 목록만 걸러져 있으면 안 된다.
		 */
		async init() {
			await this.getMemList();
			const me = this.$store.getters.getUserInfo.mem_uid;
			const mine = this.memList.find(m => String(m.mem_uid) === String(me));
			this.myMid = mine ? mine.mem_uid : '';
			// 명단을 받는 사이 담당자가 탭·검색을 먼저 바꿨으면 그 선택이 이긴다(그 목록 요청은 이미 나갔다).
			if (this.touched) return;
			if (!mine) {
				this.scopeNote = '내 담당자 정보를 확인하지 못해 전체 고객을 보여 줍니다.';
				this.getItemList(1);
				return;
			}
			this.searchOptions.mId = this.myMid;
			this.searchOptions_.mId = this.myMid;
			const ok = await this.getItemList(1);
			// 담당 고객이 아직 없는 직원에게 빈 표만 보여 주지 않는다. 전체로 넓히고 그 사실을 알린다.
			// 목록을 못 받았으면(ok=false) 0명으로 보지 않는다.
			// (2026-09 운영 실측: 임대고객은 담당자가 지정된 행이 아직 한 건도 없다.)
			if (ok && !this.touched && !this.itemList.length) {
				this.scopeNote = '내 담당 고객이 없어 전체 고객을 보여 줍니다.';
				this.myMid = '';
				this.searchOptions.mId = '';
				this.searchOptions_.mId = '';
				this.getItemList(1);
			}
		},
		getItemList(pg) {
			const seq = ++this.listSeq;
			return this.$apiGET(
				'/admin/api/user/admin2?clientType=' +
					this.searchOptions.clientType +
					'&clientName=' +
					this.searchOptions.clientName +
					'&clientMobile=' +
					this.searchOptions.clientMobile +
					'&monthly_rent_S=' +
					this.searchOptions.monthly_rent_S +
					'&monthly_rent_E=' +
					this.searchOptions.monthly_rent_E +
					'&clientLevel=' +
					this.searchOptions.clientLevel +
					'&mId=' +
					this.searchOptions.mId +
					'&findArea=' +
					this.searchOptions.findArea +
					'&page=' +
					(pg - 1) * this.itemSize,
			).then(data => {
				if (seq !== this.listSeq) return false;
				if (!data || !Array.isArray(data.item)) return false;
				for (let i = 0; i < data.item.length; i++) {
					data.item[i].brifSt = false;
				}

				this.itemList = data.item;

				this.totalCount = data.pageInfo.totalCount;
				this.page = pg;
				this.pageData = this.$pageDataSetting(this.totalCount, this.itemSize, this.blockSize, this.page);
				return true;
			});
		},
		clearInfo() {
			this.searchOptions = {
				clientType: this.searchOptions.clientType,
				clientName: '',
				clientMobile: '',
				clientLevel: ['A', 'B', 'C'],
				mId: '',
				monthly_rent_S: '',
				monthly_rent_E: '',
				findArea: '',
			};
		},
		changeMenu(menu) {
			this.touched = true;
			this.scopeNote = '';
			this.clearInfo();

			if (menu == 1) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.LESSEE;
			} else if (menu == 2) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.LANDLORD;
			} else if (menu == 3) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.BLACK;
			}

			// 임차인 탭만 내 고객으로 거른다(매매 고객 창과 같은 규칙). 선택 상자도 같은 값으로 맞춘다.
			const mId = menu == 1 ? this.myMid : '';
			this.searchOptions.mId = mId;
			this.searchOptions_.mId = mId;

			this.getItemList(1);
			this.menuType = menu;
		},
		btnStOption() {
			if (this.st) {
				this.searchOptions_.clientLevel = ['A', 'B', 'C'];
			} else {
				this.searchOptions_.clientLevel = [];
			}
		},
		btnSearch() {
			this.touched = true;
			this.scopeNote = '';
			this.searchOptions_.clientType = this.searchOptions.clientType;
			this.searchOptions = JSON.parse(JSON.stringify(this.searchOptions_));
			this.getItemList(1);
		},
		btnUserAdd() {
			this.$apiPOST('/admin/api/user/admin/add2', this.addInfo).then(data => {
				if (data.error) {
					const err = data.info;

					alert(
						'[' +
							this.$CLIENT_TYPE[err.client_type] +
							']\n[' +
							err.mgr_mem_name +
							'] 의 [' +
							err.name +
							'] 고객으로 이미 등록 되어있습니다.',
					);
				} else {
					this.getItemList(this.page);
					this.isRegisterPopupShow = false;
					alert('등록이 완료되었습니다.');
				}
			});
		},
		getMemList() {
			return this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				this.memList = Array.isArray(data) ? data : [];
			});
		},
		btnOnDetail(cid) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/LeaseUserDetail/' + cid, '', attr);
		},
		btnOnAddBrif() {
			for (let i = 0; i < this.itemList.length; i++) {
				if (this.brifSt) {
					this.itemList[i].brifSt = true;
				} else {
					this.itemList[i].brifSt = false;
				}
			}
		},
		btnOnSaveBrif() {
			this.brifList = [];
			let st = false;

			for (let i = 0; i < this.itemList.length; i++) {
				if (this.itemList[i].brifSt) {
					this.brifList.push(this.itemList[i].client_uid);
					st = true;
				}
			}

			if (!st) {
				alert('브리핑 대기 물건 저장 대상 고객을 1명 이상 선택하세요.');
				return;
			}
			if (!this.bidList.length) {
				alert('저장할 물건이 없습니다. 매물 화면에서 다시 열어 주세요.');
				return;
			}

			this.$apiPOST('/admin/api/user/admin/detail/brief2/addList', {
				bidList: this.bidList,
				brifList: this.brifList,
			}).then(re => {
				if (re !== true) return;
				// 저장한 선택을 풀어 둔다. 남겨 두면 다음 저장 때 같은 고객이 또 함께 선택된다.
				this.brifSt = false;
				this.itemList.forEach(it => (it.brifSt = false));
				alert('저장이 완료되었습니다.');
			});
		},
	},
};
</script>

<style></style>
